export default "__VITE_ASSET__CUarRFIf__"